import gql from 'graphql-tag';

export default gql`
  query getThePlace {
    getThePlace {
      id
      img_header_desktop
      img_header_mobile
      img_visual_top_desktop
      img_visual_top_mobile
      img_visual_bottom_desktop
      img_visual_bottom_mobile
      img_bg_desktop
      img_bg_mobile
      details {
        id
        title
        language_code
        block_word_title
        block_word_content
        block_video_title
        block_video_content
        block_video_cta_label
        block_video_cta_url
        block_push_title
        block_push_content
        block_push_cta_label
        block_push_cta_url
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        section_instagram_title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/thePlace/get.js